module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "HowDoesItWork p-t-3 p-b-6"
  }, [_c('h1', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.t('How does it work')))]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row p-t-4"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('i', {
    staticClass: "fa fa-search icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h5', [_c('b', [_vm._v(_vm._s(_vm.t('Search')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('Search by location and date')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('i', {
    staticClass: "fa fa-ticket icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h5', [_c('b', [_vm._v(_vm._s(_vm.t('Book')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('Make a booking and wait for a confirmation.')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('i', {
    staticClass: "fa fa-tree icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h5', [_c('b', [_vm._v(_vm._s(_vm.t('Enjoy')))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('Get in touch with nature through unique activities')))])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-06fd169f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06fd169f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/HowDoesItWork.vue
// module id = 756
// module chunks = 3